$(document).ready(function(){
    if ($('.wrap__treatment--slider').length) {
        $(".wrap__treatment--slider").slick({
            slidesToShow:1,
            adaptiveHeight:false,
            arrows:true,
            dots:true,
            swipe:false
        });
        $('.wrap__treatment--slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(".preset__bottom .consent__inner span").css("transform" ,"rotate(0deg)");
            $(".consent__inner").removeClass("opened__inner");
            $(".wrap__list--last").css("display" , "none");
            $(".wrap__elem--light").css("display" , "none");
            $(".consent__main").css("display" ,"none");
            $(".elem__list--grey").removeClass("opened__grey");
            $(".elem__list--grey span").css('transform' , "rotate(0deg)");
            $(".elem__list--light").removeClass("opened__light");
            $('.elem__list--light>span').css("transform" , "rotate(0deg)");
            $('.head__list--last').removeClass("opened__last");
            $('.head__list--last span img').attr("src" , baseURL+"/app/img/plus.png");
            $('.block__list--last').css("display" , 'none');
        });
    }
    $("body").on("click" , ".elem__link--treat>a"   ,function(e){
        e.preventDefault();
        $(this).closest(".elem__link--treat").remove();
    });

    $(".consent__inner").on("click" ,function(e){
        e.preventDefault();
        if ($(this).hasClass("opened__inner")) {
            $(this).removeClass('opened__inner');
            $(this).find("span").css('transform' , "rotate(0deg)");
            $(this).parent().find(".consent__main").slideUp(400);
            setTimeout(function(){
                $(".wrap__list--last").css("display" , "none");
                $(".wrap__elem--light").css("display" , "none");
                $(".elem__list--grey").removeClass("opened__grey");
                $(".elem__list--grey span").css('transform' , "rotate(0deg)");
                $(".elem__list--light").removeClass("opened__light");
                $('.elem__list--light>span').css("transform" , "rotate(0deg)");
                $('.head__list--last').removeClass("opened__last");
                $('.head__list--last span img').attr("src" , baseURL+"/app/img/plus.png");
                $('.block__list--last').css("display" , 'none');
            },  400);
        } else {
            $(this).addClass("opened__inner");
            $(this).find("span").css('transform' , "rotate(180deg)");
            $(this).parent().find(".consent__main").slideDown(400);
            $('html').animate({
                    scrollTop: $(".consent__inner").offset().top
                }, 500
            );
        }
    });
    $('.elem__list--grey').on('click' ,function(e){
        e.preventDefault();
        if ($(this).hasClass("opened__grey")) {
            $(this).removeClass("opened__grey");
            $(this).find("span").css('transform' , "rotate(0deg)");
            $(this).parent().find(".wrap__elem--light").slideUp(400);
        } else {
            $(this).addClass("opened__grey");
            $(this).parent().find(".wrap__elem--light").slideDown(400);
            if ($(window).width() > 767) {
                $('html').animate({
                        scrollTop: $(".consent__button").offset().top
                    }, 500
                );
            }
            $(this).find("span").css('transform' , "rotate(180deg)");
        }
    });

    $('.elem__list--light').on('click' ,function(e){
        e.preventDefault();
        if ($(this).hasClass("opened__light")) {
            $(this).removeClass("opened__light");
            $(this).find("span").css('transform' , "rotate(0deg)");
            $(this).parent().find(".wrap__list--last").slideUp(400);
        } else {
            $(this).addClass("opened__light");
            $(this).parent().find(".wrap__list--last").slideDown(400);
            $(this).find("span").css('transform' , "rotate(180deg)");
        }
    });
    $(".head__list--last").on("click" ,function(e){
        e.preventDefault();
        if ($(this).hasClass("opened__last")) {
            $(this).removeClass("opened__last");
            $(this).find("span>img").attr("src" , baseURL+"/app/img/plus.png");
            $(this).parent().find(".block__list--last").slideUp(400);
        } else {
            $(this).addClass("opened__last");
            $(this).parent().find(".block__list--last").slideDown(400);
            $(this).find("span>img").attr("src" , baseURL+"/app/img/xclose.png");
        }
    });

    $(".block__list--last ul li p").on("click" ,function(e){
        if ($(this).find("input").prop("checked") == true) {
            $(this).find('input').prop("checked" , false);
        } else {
            $(this).find('input').prop("checked" , true);
            if ($(this).closest(".inner__treat--slider").length) {
                $(this).closest(".inner__treat--slider").find(".wrap__linked--inner").append("<div class='elem__link--treat'> <div class='txt__link--treat'><p>"+$(this).text()+"</p></div> <a href='#' tabindex='0'><img src='"+baseURL+"/app/img/closetreat.png' alt='close'></a></div>");
            }
        }
    });

    if ($(".inner__slider").length) {
        $(".inner__slider").slick({
            dots:true,
            arrows:true
        });
    }

    $(".patient__elem.drop__patient--block>.wrap__patient--drop").on('click' ,function(e){
        if (!$(this).parent().hasClass("search__patient--block") && !$(this).parent().hasClass("preset__patient--block"))  {
            if ($(this).parent().hasClass("active__drop--block")) {
                $(this).parent().removeClass("active__drop--block");
                $(this).parent().find(".drop__search").slideUp(400);
            } else {
                $(this).parent().addClass("active__drop--block");
                $(this).parent().find(".drop__search").slideDown(400);
            }
        } else {
            if ($(this).parent().hasClass("search__patient--block")) {
                if ($(this).parent().hasClass("active__drop--block")) {
                    $(this).parent().removeClass("active__drop--block");
                    $(this).parent().find(".search__consent").slideUp(400);
                } else {
                    $(this).parent().addClass("active__drop--block");
                    $(this).parent().find(".search__consent").slideDown(400);
                }
            } else {
                if ($(this).parent().hasClass("active__drop--block")) {
                    $(this).parent().removeClass("active__drop--block");
                    $(this).parent().find(".preset__block").slideUp(400);
                    $(this).css('border-bottom-left-radius' , "4px");
                    $(this).css('border-bottom-right-radius' , "4px");
                } else {
                    $(this).parent().addClass("active__drop--block");
                    $(this).css('border-bottom-left-radius' , "0px");
                    $(this).css('border-bottom-right-radius' , "0px");
                    $(this).parent().find(".preset__block").slideDown(400);
                }
            }
        }
    });
    $('.signed-forms-select').on(('click'), function (event) {
        if ($(this).parent().hasClass("active__drop--block")) {
            $(this).parent().removeClass("active__drop--block");
            $(this).parent().find(".signed_search").slideUp(400);
        } else {
            $(this).parent().addClass("active__drop--block");
            $(this).parent().find(".signed_search").slideDown(400);
        }
    });

    $('.sent-forms-select').on(('click'), function (event) {
        if ($(this).parent().hasClass("active__drop--block")) {
            $(this).parent().removeClass("active__drop--block");
            $(this).parent().find(".sent_search").slideUp(400);
        } else {
            $(this).parent().addClass("active__drop--block");
            $(this).parent().find(".sent_search").slideDown(400);
        }
    });

    $('.admin-dropdown-title').on(('click'), function (event) {
        if ($(this).parent().hasClass("active__drop--block")) {
            $(this).parent().removeClass("active__drop--block");
            $(this).parent().find(".admin-dropdown-menu").slideUp(400);
        } else {
            $(this).parent().addClass("active__drop--block");
            $(this).parent().find(".admin-dropdown-menu").slideDown(400);
        }
    });
    $(".inner__section").on("click" ,function(e){
        if ($(this).hasClass("opened__section")) {
            $(this).removeClass("opened__section");
            $(this).find("span").css("transform" , "rotate(0deg)");
            $(this).parent().find(".drop__search").slideUp(400);
        } else {
            $(this).addClass("opened__section");
            $(this).find("span").css("transform" , "rotate(180deg)");
            $(this).parent().find(".drop__search").slideDown(400);
        }
    });
    $(".top__text").on("click" ,function(e){
        e.preventDefault();
        $(this).parent().find("textarea").scrollTop($(this).parent().find("textarea").scrollTop() - 30);
    });
    $(".bottom__text").on("click" ,function(e){
        e.preventDefault();
        $(this).parent().find("textarea").scrollTop($(this).parent().find("textarea").scrollTop() + 30);
    });
    $(window).resize(function(){
        $(".elem__photo--switcher").each(function(index,elem){
            $(elem).css("height" , $(elem).css("width"));
        });
        $(".inner__container--photo").css("height" , $(".inner__container--photo").css("width"));
    });
    $(".inner__container--photo").css("height" , $(".inner__container--photo").css("width"));
    $(".elem__photo--switcher").each(function(index,elem){
        $(elem).css("height" , $(elem).css("width"));
    });
    if ($("#sign__blockother").length) {
        $("#sign__blockother").jSignature({
            lineWidth:1,
            color:"#000"
        });
    }

    if ($("#sign__block").length) {
        $("#sign__block").jSignature({
            lineWidth:1,
            color:"#000"
        });
    }
    if ($("#sign__block2").length) {
        $("#sign__block2").jSignature({
            lineWidth:1,
            color:"#000"
        });
    }

    $('.email__document>.elem__document--wrap').on('click' ,function(e){
        e.preventDefault();
        if ($(this).hasClass("opened__document")) {
            $(this).removeClass("opened__document");
            $(this).find(".elem__right>span").css("transform" , "rotate(0deg)");
            $(this).parent().find(".email__wrapper--docs").slideUp(400);
        } else {
            $(this).addClass("opened__document");
            $(this).find(".elem__right>span").css("transform" , "rotate(180deg)");
            $(this).parent().find(".email__wrapper--docs").slideDown(400);
        }
    });
    $(".print__document>.elem__document--wrap").on('click' ,function(e){
        e.preventDefault();
        if ($(this).hasClass("opened__document")) {
            $(this).removeClass("opened__document");
            $(this).find(".elem__right>span").css("transform" , "rotate(0deg)");
            $(this).parent().find(".printer__wrapper--docs").slideUp(400);
        } else {
            $(this).addClass("opened__document");
            $(this).find(".elem__right>span").css("transform" , "rotate(180deg)");
            $(this).parent().find(".printer__wrapper--docs").slideDown(400);
        }
    });

    $(".view__document>.elem__document--wrap").on('click' ,function(e){
        e.preventDefault();
        if ($(this).hasClass("opened__document")) {
            $(this).removeClass("opened__document");
            $(this).find(".elem__right>span").css("transform" , "rotate(0deg)");
            $(this).parent().find(".view__docs--block").slideUp(400);
        } else {
            $(this).addClass("opened__document");
            $(this).find(".elem__right>span").css("transform" , "rotate(180deg)");
            $(this).parent().find(".view__docs--block").slideDown(400);
        }
    });
    $('.elem__photo--switcher').on("click" ,function(e){
        $('.elem__photo--switcher').removeClass("active__switcher");
        $(this).addClass("active__switcher");
        $(".inner__container--photo>.image__catcher").css("background" , "url("+$(this).attr('data-src')+")");
        // $(".inner__container--photo>.main__photo--picker>img").attr("src" , $(this).attr("data-src"));
    });


    $(".elem__point--group input").on("change" ,function(e){
        if ($(this).attr("id") == "person" && $(this).prop("checked")) {
            $('input[name="legal_guardian"]').prop('required', false);
            $(".point__full--name").slideUp(400);
        } else {
            $('input[name="legal_guardian"]').prop('required', true);
            $(".point__full--name").slideDown(400);
        }
    });
    if ($("#holder").length) {
        var holder = document.getElementById('holder');
        holder.ondragover = function () { this.className = 'holder'; return false; };
        holder.ondrop = function (e) {
            this.className = 'hidden';
            e.preventDefault();
            $(this).find("p").each(function(index,elem){
                $(elem).css("display" , "none");
            });
            var file = e.dataTransfer.files[0];
            var reader = new FileReader();
            reader.onload = function (event) {
                document.getElementById('image_droped').className='visible';
                $('#image_droped').css("display" , "block");
                $('#image_droped').attr('src', event.target.result);
            }
            reader.readAsDataURL(file);
        };
    }

    if ($(".inner__welcome").length) {
        if ($(window).width() > 480) {
            $(".inner__welcome").css({"width" : "165px" , "height" : "165px"  });
            setTimeout(function(){
                $(".inner__welcome img").css("transform"  , "scale(1)");
            } , 400);
        } else {
            $(".inner__welcome").css({"width" : "120px" , "height" : "120px"  });
            setTimeout(function(){
                $(".inner__welcome img").css("transform"  , "scale(1)");
            } , 400);
        }
    }

    $(".wrap__list--top").on("click" ,function(e){
        if ($(this).hasClass("active__list")) {
            $(this).find("span").css("transform" , "rotate(0deg)");
            $(this).removeClass("active__list");
            $(this).parent().find(".list__group--dropdown").slideUp(400);
        } else {
            $(this).addClass("active__list");
            $(this).find("span").css("transform" , "rotate(180deg)");
            $(this).parent().find(".list__group--dropdown").slideDown(400);
        }
    });
    $(".menu__list ul li a").on("mouseenter" ,function(){
        if (!$(this).parent().hasClass('active__menu')) {
            $(this).find("img").attr("src" , baseURL+"/app/img/menublue.svg");
        }
    });
    $(".menu__list ul li a").on("mouseleave" ,function(){
        if (!$(this).parent().hasClass('active__menu')) {
            $(this).find("img").attr("src" , baseURL+"/app/img/menuwhite.svg");
        }
    });
    $(".left__header a").on("click" ,function(e){
        e.preventDefault();
        $(".menu__float").css("left" , "0px");
    });
    $(".dropdown-toggle").on("click" ,function(e){
        e.preventDefault();
        if ($(this).hasClass("open__drop")) {
            $(this).removeClass("open__drop");
            $(".dropdown .dropdown-menu").fadeOut(400);
        } else {
            $(this).addClass("open__drop");
            $(".dropdown .dropdown-menu").fadeIn(400);
        }
    });
    $(".close__button a").on('click' ,function(e){
        $(".menu__float").css("left" , "-400px");
    });
    $(".pass__show").on("click" ,function(e){
        e.preventDefault();
        if ($(this).parent().find("input").attr("type") == "password") {
            $(this).parent().find("input").attr("type" , "text");
        } else {
            $(this).parent().find("input").attr("type" , "password");
        }
    });
    $(".group__status--effect>input , .profile__card>div input , .group__patient>input , .point__full--name>input").on("focus" ,function(e){
        e.preventDefault();
        if ($(this).attr("readonly") != "readonly") {
            $(this).parent().find("p").css("color" , "#00D5CC");
        }
    });
    $(".group__status--effect>input ,  .profile__card>div input , .group__patient>input , .point__full--name>input").on("blur" ,function(e){
        e.preventDefault();
        $(this).parent().find("p").css("color" , "#000");
        var currentElem = $(this);
        setTimeout(function(){
            $(currentElem).closest(".group__patient").find('.drop__search>ul>li').css("display"  , "block");
        } ,1000);
    });
    $(".search__input--group>input").on("focus" ,function(e){
        if ($(this).attr("readonly") != "readonly") {
            $(this).parent().find(".drop__search").fadeIn(400);
        }
    });
    $(".search__input--group>input").on("blur" ,function(e){
        if ($(this).attr("readonly") != "readonly") {
            $(this).parent().find(".drop__search").fadeOut(400);
        }
    });
    $(".dropdown__custom>input").on("focus" ,function(e){
        $(this).closest(".dropdown__custom").find(".drop__search").fadeIn(400);
    });
    $(".dropdown__custom>input").on("blur" ,function(e){
        $(this).closest(".dropdown__custom").find(".drop__search").fadeOut(400);
    });
    $(".drop__search ul li a").on('click' ,function(e){
        e.preventDefault();
        $(this).closest(".group__patient").find("input").val($(this).text());
        $(this).closest(".drop__search").fadeOut(400);
    });
    $(".group__main--card>input , .card__number--block>input").on("keypress" ,function(e){
        if(e.charCode < 48 || e.charCode > 57) return false;
        e.target.value = e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
    });
    $(".group__cvc>input , .cvc__block>input").on("keypress" ,function(e){
        if(e.charCode < 48 || e.charCode > 57) return false;
    });
    $(".group__date>input , .date__expire>input").on("keypress" , function(e){
        if(e.charCode < 48 || e.charCode > 57) return false;
        if ($(this).val().length == 2) {
            $(this).val($(this).val() + "/");
        }
    });
    $(".group__promo>input").on("keypress" ,function(e){
        if(e.charCode < 48 || e.charCode > 57) return false;
        e.target.value = e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
    });

    $(".date__input>input , .outer__sign .data__right>input").on("keypress" ,function(e){
        if(e.charCode < 48 || e.charCode > 57) return false;
        if ($(this).val().length == 2 || $(this).val().length == 5 ) {
            $(this).val($(this).val() + "/");
        }
    });

    $(".group__patient>input").on("input" ,function(e){
        e.preventDefault();
        var elemVal = $(this).val().toLowerCase();
        $(this).closest(".group__patient").find('.drop__search>ul>li').each(function(index,elem){
            if ($(elem).find("a").text().toLowerCase().indexOf(elemVal) == -1){
                $(elem).css("display" , "none")
            } else {
                $(elem).css("display" , "block");
            }
        });
    });
});
